import {
  AppBar,
  Toolbar,
  IconButton,
  Box
} from '@mui/material';
import PropTypes from 'prop-types';
import MenuIcon from '@mui/icons-material/Menu';
import Breadcrumb from './Breadcrumb';
import UserAvatarMenu from '../common/UserAvatarMenu';

/**
 * DashboardHeader - Dashboard top header with breadcrumb and user menu
 * 
 * Features:
 * - Mobile hamburger menu button
 * - Breadcrumb navigation
 * - User avatar dropdown menu (reusable component)
 * 
 * Props:
 * @param {number} drawerWidth - Sidebar width for responsive layout
 * @param {function} handleDrawerToggle - Toggle mobile drawer
 */
const DashboardHeader = ({ drawerWidth, handleDrawerToggle }) => {
  return (
    <AppBar
      position="fixed"
      sx={{
        width: { md: `calc(100% - ${drawerWidth}px)` },
        ml: { md: `${drawerWidth}px` },
        bgcolor: 'background.paper',
        color: 'text.primary',
        boxShadow: 1
      }}
    >
      <Toolbar>
        {/* Mobile Menu Button */}
        <IconButton
          color="inherit"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { md: 'none' } }}
        >
          <MenuIcon />
        </IconButton>

        {/* Breadcrumb */}
        <Box sx={{ flexGrow: 1 }}>
          <Breadcrumb />
        </Box>

        {/* User Avatar Menu (Reusable Component) */}
        <UserAvatarMenu showGreeting={false} variant="dashboard" />
      </Toolbar>
    </AppBar>
  );
};

DashboardHeader.propTypes = {
  drawerWidth: PropTypes.number.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired
};

export default DashboardHeader;

